import { render, staticRenderFns } from "./index.vue?vue&type=template&id=532ef04b&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=532ef04b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532ef04b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('532ef04b')) {
      api.createRecord('532ef04b', component.options)
    } else {
      api.reload('532ef04b', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=532ef04b&scoped=true&", function () {
      api.rerender('532ef04b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/AppMore/index.vue"
export default component.exports